@if ({ list: list$ | async, loading: deliveryInfoLoading$ | async, error:
deliveryInfoError$ | async, data: productReferenceData$ | async, mixedDates:
mixedDeliveryDates$ | async, singleDate: singleDeliveryDate$ | async, disabled:
disabled$ | async, multiplier: multiplier$ | async, totalAvailable:
totalAvailableItems$ | async, showCommercialListMultiplier:
showCommercialListMultiplier$ | async, hasSizeMissedPrice: hasSizeMissedPrice$ |
async }; as ctx) {
<!-- Delivery date -->
@if (ctx.totalAvailable > 0) {
<div class="dates-container">
  <p
    class="text-muted mb-1 d-none d-md-block"
    i18n="
      commercialList|Commercial List delivered
      description@@commercialListDeliveryDescriptionText"
  >
    The package will be delivered:
  </p>
  @if (ctx.mixedDates) {
  <div class="d-flex flex-column bold-text" data-e2e="dates-text">
    <span>
      {{ ctx.mixedDates.text }}
    </span>
    <span
      class="note-text text-muted mt-2 d-none d-md-block"
      i18n="
        commercialList|see dates below note@@commercialListSeeDatesBelowNote"
    >
      See the specific dates for each product below
    </span>
  </div>
  } @if (ctx.singleDate) {
  <div class="bold-text">
    <span>{{ ctx.singleDate | utcDate: 'MMM dd, yyyy' }}</span>
  </div>
  }
</div>
}
<!-- Quantity container -->
@if (ctx.totalAvailable > 0) {
<div class="multiplier-container" data-e2e="quantity-selector">
  <p
    class="text-muted mb-1 d-none d-md-block"
    i18n="
      commercialList|Commercial List quantity
      header@@commercialListQuantityHeader"
  >
    Quantity:
  </p>
  <span
    class="bold-text cursor-pointer"
    [atxPopover]="
      ctx.showCommercialListMultiplier ? multiplierOptionsTemp : undefined
    "
  >
    {{ ctx.multiplier }}
    @if (ctx.showCommercialListMultiplier) {
    <fa-icon [icon]="['fas', 'chevron-down']" size="xs" class="ml-1"></fa-icon>
    }
  </span>
  <ng-template #multiplierOptionsTemp>
    <ul class="option-list">
      @for (option of multiplierOptions; track option) {
      <li
        class="px-3 py-2 option"
        [class.active]="ctx.multiplier === option"
        (click)="multiply(option, ctx.list.id)"
      >
        {{ option }}
      </li>
      }
    </ul>
  </ng-template>
</div>
}
<!-- Totals and action button -->
@if (ctx.data) {
<div class="totals-container">
  <div class="delivery-info d-flex justify-content-end">
    @if ( ctx.data.allItemTotals.totalRequestedQuantity !==
    ctx.data.availableItemTotals.totalRequestedQuantity ) {
    <s class="mr-2 total-items-warning text-primary font-weight-bold">{{
      ctx.data.allItemTotals.totalRequestedQuantity
    }}</s>
    } @if (ctx.totalAvailable > 0 && ctx.multiplier > 1) {
    <span
      i18n="commercialList|multiplier note@@commercialListMultiplierNote"
      class="text-muted mr-2"
    >
      {{ ctx.multiplier }} x
    </span>
    }
    <strong
      class="text-primary"
      i18n="
        commercialList|available item count@@commercialListAvailableItemCount"
    >
      {{ ctx.data.availableItemTotals.totalRequestedQuantity }} items
    </strong>
    <span class="ml-2">
      @if (ctx.data.availableItemTotals.totalPrice === 0) {
      <span
        atxTooltip="Package price is missing for the requested delivery date"
        i18n-atxTooltip="
          commercialList|available items missed price total
          tooltip@@commercialListPackageMissedTooltipText"
        i18n="
          commercialList|available items missed price
          total@@commercialListPackageMissedText"
      >
        n/a
      </span>
      } @else {
      <span
        [class.text-warning]="ctx.hasSizeMissedPrice"
        [tooltipEnabled]="ctx.hasSizeMissedPrice"
        atxTooltip="The total amount is not accurate as some EAN prices are missing"
        i18n-atxTooltip="
          commercialList|Total ammount is not accurate
          tooltip@@commercialListNotAccurateTotalAmmountTooltipText"
      >
        {{
          ctx.data.availableItemTotals.totalPrice
            | formatPrice: ctx.data.currency
        }}
      </span>
      }
      <ng-template #totalPrice>
        <span
          [class.text-warning]="ctx.hasSizeMissedPrice"
          [tooltipEnabled]="ctx.hasSizeMissedPrice"
          atxTooltip="The total amount is not accurate as some EAN prices are missing"
          i18n-atxTooltip="
            commercialList|Total ammount is not accurate
            tooltip@@commercialListNotAccurateTotalAmmountTooltipText"
        >
          {{
            ctx.data.availableItemTotals.totalPrice
              | formatPrice: ctx.data.currency
          }}
        </span>
      </ng-template>
    </span>
  </div>
</div>
}
<!-- Button and error -->
<div class="button-container">
  @if (ctx.error) {
  <div class="text-danger mb-1">
    {{ ctx.error }}
  </div>
  }
  <button
    [disabled]="!!ctx.disabled"
    class="btn btn-primary btn-lg w-100 w-md-auto"
    (click)="shopTheBasket(ctx.list.id, ctx.data.productReferences)"
    data-e2e="shop-the-basket"
  >
    @if (ctx.loading) {
    <fa-icon
      [icon]="['fas', 'spinner']"
      spin="true"
      [pulse]="true"
      class="mr-2"
    ></fa-icon>
    }
    <span [atxTooltip]="ctx.disabled">
      {{ buttonText$ | async }}
    </span>
  </button>
</div>
} @if (showCommercialListLoader$ | async) {
<atx-loader-overlay
  loaderText="Adding list products to your basket..."
  i18n-loaderText="
    commercialList|Updating basket loader
    text@@commercialLsitUpdatingBasketLoaderText"
></atx-loader-overlay>
}
